const ITEM_TYPE_PRINT = `print`;
const PREFIX = {
  type: 'item_type',
  size: 'print_size',
  finish: 'print_finish',
  border: 'print_border',
};

export default class ViewingSizeKey {
  static validForSizesWithPrints(sizes, viewingSizeKey) {
    return sizes.some(size => size.key === viewingSizeKey);
  }

  constructor(viewingSizeKey) {
    this.viewingSizeKey = viewingSizeKey;
  }

  create({ size, finish, border }) {
    if (!size || !finish) {
      return undefined;
    }

    const typeKey = `${PREFIX.type}--${ITEM_TYPE_PRINT}`;
    const finishKey = `${PREFIX.finish}--${finish}`;
    const sizeKey = `${PREFIX.size}--${size}`;
    const borderKey = `${PREFIX.border}--${border ? border : "no"}`;

    return this.join([typeKey, sizeKey, finishKey, borderKey]);
  }

  update(key, value) {
    if (!this.viewingSizeKey) {
      return undefined;
    }

    const keysArr = Object.entries(this.properties()).reduce(
      (arr, [currentKey, currentValue]) => {
        if (currentKey === key) {
          arr.push(`${PREFIX[key]}--${value}`);
        } else {
          arr.push(currentValue);
        }
        return arr;
      },
      []
    );

    return this.join(keysArr);
  }

  properties() {
    const [type, size, finish] = this.viewingSizeKey.split(';');

    return { type, size, finish };
  }

  join(properties) {
    return properties.filter(Boolean).join(';');
  }
}
